function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "help-octagon",
    clipPath: "url(#clip0_487_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.81747 6.74999C6.9938 6.24874 7.34184 5.82607 7.79994 5.55684C8.25804 5.28761 8.79664 5.1892 9.32036 5.27903C9.84407 5.36886 10.3191 5.64113 10.6613 6.04764C11.0035 6.45414 11.1908 6.96863 11.19 7.49999C11.19 8.99999 8.93997 9.74999 8.93997 9.74999M9 12.75H9.0075M1.5 6.39206L1.5 11.6079C1.5 11.7914 1.5 11.8831 1.52072 11.9694C1.5391 12.0459 1.5694 12.1191 1.61052 12.1862C1.6569 12.2619 1.72176 12.3268 1.85147 12.4565L5.54353 16.1485C5.67324 16.2782 5.7381 16.3431 5.81379 16.3895C5.88089 16.4306 5.95405 16.4609 6.03058 16.4793C6.11689 16.5 6.20861 16.5 6.39206 16.5H11.6079C11.7914 16.5 11.8831 16.5 11.9694 16.4793C12.0459 16.4609 12.1191 16.4306 12.1862 16.3895C12.2619 16.3431 12.3268 16.2782 12.4565 16.1485L16.1485 12.4565C16.2782 12.3268 16.3431 12.2619 16.3895 12.1862C16.4306 12.1191 16.4609 12.0459 16.4793 11.9694C16.5 11.8831 16.5 11.7914 16.5 11.6079V6.39206C16.5 6.20861 16.5 6.11689 16.4793 6.03058C16.4609 5.95405 16.4306 5.88089 16.3895 5.81379C16.3431 5.7381 16.2782 5.67324 16.1485 5.54353L12.4565 1.85147C12.3268 1.72176 12.2619 1.6569 12.1862 1.61052C12.1191 1.5694 12.0459 1.5391 11.9694 1.52072C11.8831 1.5 11.7914 1.5 11.6079 1.5L6.39206 1.5C6.20861 1.5 6.11689 1.5 6.03058 1.52072C5.95405 1.5391 5.88089 1.5694 5.81379 1.61052C5.7381 1.6569 5.67324 1.72176 5.54353 1.85147L1.85147 5.54353C1.72176 5.67324 1.6569 5.7381 1.61052 5.81379C1.5694 5.88089 1.5391 5.95405 1.52072 6.03058C1.5 6.11689 1.5 6.20861 1.5 6.39206Z",
    stroke: "#AD87FF",
    style: {
      stroke: "#AD87FF",
      stroke: "color(display-p3 0.6779 0.5289 0.9992)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_1912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.aa773680891ee13d8ce1ee94ebd88568.svg";
export { ForwardRef as ReactComponent };